<script setup lang="ts">
import type { Props } from './types';

defineProps<Props>();
</script>

<template>
	<div class="top-forms-optionLabel">
		<div
			:class="{
			  'top-forms-optionLabel_title': true,
			  'top-forms-optionLabel_title-disabled': disabled,
			}"
		>
			<!-- @slot Слот с заголовком -->
			<slot></slot>
		</div>

		<div
			v-if="description"
			class="top-forms-optionLabel_description"
			:class="{'top-forms-optionLabel_description-disabled': disabled}"
		>
			{{ description }}
		</div>
	</div>
</template>

<style>
.top-forms-optionLabel {
	flex-grow: 1;
}

.top-forms-optionLabel_title {
	color: var(--color-text-1);
	min-height: var(--top-forms-option-height);
	display: flex;
	align-items: center;
}

.top-forms-optionLabel_title-disabled {
	color: var(--color-text-3);
}

.top-forms-optionLabel_description {
	color: var(--color-text-2);
	font-size: 0.85em;
	line-height: var(--top-forms-option-height);
}

.top-forms-optionLabel_description-disabled {
	color: var(--color-text-3);
}
</style>
